<template>
  <div class="content">
    <div class="foot_tips">
      <span>友情链接:</span>
      <ul class="foot_link">
        <a  :href="item.content" target="_blank" v-for="(item,index) in linList" :key="index">{{item.name}} </a>
      </ul>
    </div>
    <div class="foot_body">
      <div class="foot_in">
        <div class="foot_left">
          <!-- <img src="../assets/images/img_3.jpg" alt="" /> -->
          <img src="../assets/images/logo.jpg" alt="">
          <p>{{bart.content}}</p>
           <!--<p>平台电话：0531-84993009 &nbsp;&nbsp;&nbsp;小智电话：1866377527</p>-->
           <p>{{content.content}}</p>
        </div>
        <div class="foot_right">
          <ul class="foot_map">
            <li>
              <router-link active-class="active" to="/chapter_users" exact
                >关于我们</router-link
              >
            </li>
            <li>
              <router-link
                active-class="active"
                to="/environmental_college"
                exact
                >环学院</router-link
              >
            </li>
            <li>
              <router-link to="/platform_entry">会员服务</router-link>
            </li>
            <li>
              <router-link to="/advertising_services">广告服务</router-link>
            </li>
            <li>
              <router-link to="/demand">发布需求</router-link>
            </li>
            <li v-show="show">
              <router-link to="/corporate_supply">发布供应</router-link>
            </li>
            <li>
              <router-link to="/contact_us">联系我们</router-link>
            </li>
          </ul>
          <!--二维码-->
          <ul class="foot_code">
            <li v-for="(info,index) in codeList" :key="index">
              <img :src="info.content" alt="" />
              <p>{{info.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="foot_line"></div>
      <!-- <div class="foot_message">{{copy.content}}</div> -->
      <div class="foot_message">
        {{copy.content}} <a @click="onCopy">版权声明</a> <a @click="onConceal">隐私政策</a>
      </div>
      <div class="foot_permit">
        <!-- <p v-for="(info,index) in permitList" :key="index">{{info.content}}</p> -->
        <a :href="info.des" target="_blank"  v-for="(info,index) in permitList" :key="index">{{info.content}}</a>
      </div>
    </div>
     <!--版权声明 和隐私协议-->
     <div class="sett_dialog" v-show="dialogVisible">
        <div class="sett_cox"></div>
        <div class="sett_dialog_box">
          <div class="sett_matter">
            <p class="sett_title">{{agrTex}}</p>
            <p v-if="agrTex == '版权声明'" class="sett_jitr">
              <span v-if="!isImg">{{ time }}s</span>
              <img
                v-show="isImg"
                src="../assets/images/sign.png"
                @click.prevent="onText()"
              />
            </p>
            <p v-else class="sett_jitr">
              <span v-if="!isImgs">{{ times }}s</span>
              <img
                v-show="isImgs"
                src="../assets/images/sign.png"
                @click.prevent="onText()"
              />
            </p>
          </div>
          <div class="sett_desc" v-if="agrTex == '版权声明'"   v-html="copyAgreement.des"></div>
          <div class="sett_desc" v-else   v-html="hideAgreement.des"></div>
        </div>
     </div>

     
  </div>
</template>

<script>
import {link,getQr,copyright,cppermit,agreement} from "@/api/coment"
export default {
  name: "footCom",
  data(){
	return{
	  linList:[],
	  codeList:[],
    copy:{},
    content:{},
    bart:{},
    show:false,
    permitList:[],
    dialogVisible:false,
    time:10,
    times:10,
    agrTex:'版权声明',
    copyAgreement:'',
    hideAgreement:'',
    isImg:false,
    isImgs:false
	}
  },
  created(){
	 this.getLink();
	 this.getQr();
   this.getCopy();
   this.getCppermit();
   this.getAgreement();
   if(this.$store.state.user.userInfo != null){
      let type = this.$store.state.user.userInfo.type;
      type == 3 ? this.show = true : this.show = false;
   }else{
     this.show = true;
   }
  },
  methods:{
    getLink(){
      link().then((res)=>{    
      if(res.code == 0) this.linList = res.page;
      }).catch((err)=>{})
    },
    getQr(){
      getQr().then((res)=>{
	  if(res.code ==0){
		 res.page.forEach((item)=>{
		    if(item.id !=50){
			  this.codeList.push(item)
			}
		 });
	  }
      }).catch((err)=>{})
    },
    getCopy(){
      copyright().then((res)=>{
      if(res.code == 0){
        this.copy = res.page[0];
        this.content= res.page[1];
        this.bart = res.page[2]
      }
      }).catch((err)=>{})
    },
    //查询备案信息
    getCppermit(){
      cppermit().then((res)=>{
        if(res.code == 0) this.permitList = res.page;
      }).catch((err)=>{})
    },
    //版权
    onCopy(){
     this.agrTex = '版权声明'
     this.dialogVisible = true;
     this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    //隐私
    onConceal(){
      this.dialogVisible = !this.dialogVisible;
      this.agrTex = '隐私政策'
      this.timers = setInterval(() => {
        this.times--;
        if (this.times == 0) {
          clearInterval(this.timers);
          this.isImgs = true;
        }
      }, 1000);
    },
    //获取协议声明
    getAgreement() {
      agreement()
        .then((res) => {
          this.copyAgreement = res.page.filter(
            (item) => item.name == "版权声明"
          )[0];     
          this.hideAgreement = res.page.filter(
            (item) => item.name == "隐私政策"
          )[0];
        })
        .catch((err) => {});
    },
    onText(){
      this.dialogVisible = false ;
    },
    onRemove(){
      let orr = window.document.getElementsByTagName("ins");
        let newbridegesum=0;
        for(let i=0;i<orr.length;i++){
        if("newBridge"== orr[i].getAttribute("id")){
            newbridegesum+=1;
            if( newbridegesum>1){
                orr[i].outerHTML=""
            }
        }      
        }
    }
  },
  mounted(){
    this.onRemove()
  }
};
</script>

<style  lang="less" scoped>
.content {
  width: 100%;
  height: 54px;
  margin-top: 100px;
  background: rgb(67, 66, 66);
  .foot_tips {
    width: 1080px;
    line-height: 54px;
    background: rgb(67, 66, 66);
    margin: 0 auto;
    color: #BEBEBE;
    display: flex;
    // @media (min-width: 1600px) {
    //   width: 60%;
    // }
    span {
      margin-right: 10px;
      font-size: 14px;
    }
    ul {
      display: flex;
      font-size: 14px;
      li {
        margin-right: 20px;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
  .foot_body {
    width: 100%;
    // height: 282px;
    background: rgb(43, 43, 43);
    .foot_in {
      padding-top: 35px;
      display: flex;
      justify-content: space-between;
      width: 1080px;
      margin: 0 auto;
      background: rgb(43, 43, 43);
      // @media (min-width: 1600px) {
      //   width: 60%;
      // }
      .foot_left {
        text-align: left;
        p {
          margin-top: 5px;
          color: #BEBEBE;
          font-size: 14px;
        }
        img {
          width: 220px;
          margin: 0 0 20px;
        }
      }
      .foot_right {
        text-align: right;
        .foot_map {
          display: flex;
          justify-content: space-between;
          color: #BEBEBE;
          li {
            margin-right: 10px;
            &::before {
              margin-right: 10px;
              display: inline-block;
              content: "";
              width: 2px;
              height: 10px;
              background: #434242;
            }
            a{
              color: #BEBEBE;
              font-size: 14px;
            }
            &:first-of-type {
              &::before {
                display: inline-block;
                content: "";
                width: 0px;
                height: 0px;
                background: #434242;
              }
            }
          }
        }
        .foot_code {
          margin-top: 27px;
          display: flex;
          justify-content: flex-end;
          li {
            margin-right: 12px;
            img{
              width: 90px;
            }
            p {
              text-align: center;
              color: #BEBEBE;
              font-size: 14px;
            }
          }
        }
      }
    }
    .foot_line {
      margin-top: 30px;
      border-top: 1px dashed #434242;
    }
    .foot_message {
      text-align: center;
      line-height: 3;
      font-size: 14px;
      color: #BEBEBE;
      a{
        font-size: 14px !important;
        color: #BEBEBE !important;
        margin-right: 10px;  
        &:hover{
        text-decoration:underline;
        }     
      }
    }
  }
}
.foot_link a{
  margin-right: 15px;
  &:hover{
	 text-decoration:underline;
  }
}
.foot_permit{
  background:#2b2b2b;
  display: flex;
  flex-direction:column;
  align-items: center;
}
.foot_permit a{
  color: #BEBEBE !important;
  font-size: 14px;
  display:inline-block;
  margin-bottom: 5px;
  &:hover{
    text-decoration:underline;
  }
}



/**协议弹框 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}


/deep/ .el-dialog {
  width: 500px;
  height: 600px;
}
/deep/ .el-dialog__header {
  text-align: center;
}
/deep/ .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}







</style>



// WEBPACK FOOTER //
// src/common/footCom.vue